import { writable } from 'svelte/store'


const createLoading = () => {
  const { subscribe, update } = writable(0)

  const newLoading = () => update(l => l+1)
  
  const removeLoading = () => update(l => l > 0 ? l - 1 : 0)
  
  return { newLoading, removeLoading, subscribe }
}

export const loading = createLoading()